/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="ion-page">
    <ion-header no-border>
      <ion-toolbar color="primary">
        <div class="mc-home-header">
          <div class="mc-home-log">
            <img v-if="!noIconToolbar" class="background-img ion-margin-end" src="/assets/home.png" alt="" />
            <div v-if="!noTextToolbar">
              <h1 >{{ title }}</h1>
              <p>{{ subtitle }}</p>
            </div>
            <ion-icon v-if="showModuleSelector && numberOfModule > 1" name="apps" size="large" class="mc-home-switch pointer" v-on:click="showModule($event)"></ion-icon>
          </div>
        </div>

        <ion-buttons slot="secondary">
          <ion-button v-if="langs.length > 1" @click="showLangs()">
            <ion-icon slot="icon-only" icon="globe"></ion-icon>
          </ion-button>
        </ion-buttons>
		<div v-if="homeMessageDisplay"
			class="mc-st-information"
				v-show="display"
		>

			<ion-icon
				class="mc-information-icon"
				name="close"
				v-on:click="closeInformation()"
			></ion-icon>
			<div
				class="mc-information-text"
				v-html="$t('message.home.information')">
			</div>
		</div>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary">
      <img slot="fixed" v-if="instance === 'mobicoop'" class="header-img-rezo ion-margin-end" src="/assets/rezocovoit.png" alt="" />

      <UserHome />

      <div class="mc-white-container">

        <ion-card v-if="appMobileVersion && appMobileVersion.homeMessage" class="home-info" color="warning">
          <ion-card-content class="d-flex" >
            <div style="font-size: 14px;">{{ appMobileVersion.homeMessage }}</div>
          </ion-card-content>
        </ion-card>

        <SearchQuick />

        <!-- Prime -->
        <div  v-if="showMob" class="mc-block-action" v-bind:style="{ background: 'rgba('+ secondary +', 0.4)' }">
          <div class="mc-block-action-title" style="margin-bottom: 0px" v-bind:style="{ background: 'rgba('+ secondary +', 1)' }">
            <p class="d-flex align-center">
              <b>{{ $t(`Prime.title`) }}</b>
              <a v-if="!!primeInfoUrl" class="d-flex align-center" :href="primeInfoUrl" target="_blank" style="color: white; margin-left: 10px; font-size: 18px">
                <ion-icon slot="icon-only" name="information-circle"></ion-icon>
              </a>
            </p>
          </div>
          <div style="padding: 10px">
            <p class="text-center">
              <b v-html="$t(`Prime.description`)"></b>
            </p>
            <div class="mc-block-action-container-button">
              <div
                class="mc-block-action-button pointer"
                v-bind:style="{ color: 'rgba('+ secondary +', 1)'}"
                @click="$router.push('eec-incentive')"
              >
                {{ $t('Prime.description-follow') }}
              </div>
            </div>
            </div>
        </div>
        <!-- Prime -->


        <BlockAction v-if="showCommunities"
          :action="'communities'"
          :color="'rgba('+ primary+ ', 1)'"
          :colorBg="'rgba('+ primary+ ', 0.4)'"
          :icon="'briefcase'"
          @clickButton="redirectToCommunities()"
        />
        <BlockAction  v-if="showEvents"
          :action="'events'"
          :color="'rgba('+ secondary+ ', 1)'"
          :colorBg="'rgba('+ secondary+ ', 0.4)'"
          :icon="'musical-note'"
          @clickButton="redirectToEvents()"
        />
        <BlockAction v-if="showSolidarity"
          :action="solidaryType"
          :color="'rgba('+ success+ ', 1)'"
          :colorBg="'rgba('+ success+ ', 0.4)'"
          :icon="'thumbs-up'"
          :secondButton="true"
          @clickButton="solidaryType == 'solidarity' ? redirectToSolidarity() : redirectToMob()"
          @clickSecondButton="redirectToSolidarityPost()"
        />

        <div class="mc-download-app" v-if="isNotCapacitor && appMobileVersion && appMobileVersion.androidRecommendedLink && appMobileVersion.iosRecommendedLink">
          <div>
            <p class="text-center"><b>Retrouvez nos applications mobiles sur les stores</b></p>
          </div>
          <ion-grid>
            <ion-row>
              <ion-col class="d-flex align-center" style="margin-right: 10px">
                <a style="width: 100%" :href="appMobileVersion.iosRecommendedLink" target="_blank"><img style="width: 100%" src="/assets/download_appstore.svg"  alt="" /></a>
              </ion-col>
              <ion-col class="d-flex align-center" style="margin-left: 10px">
                <a style="width: 100%" :href="appMobileVersion.androidRecommendedLink" target="_blank"><img style="width: 100%" src="/assets/download_googleplay.png"  alt="" /></a>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>

        <ion-button
          class="mc-big-button"
          color="primary"
          expand="block"
          fill="outline"
          v-if="showRelaypoints"
          v-on:click="redirectToRelaypoints()"
        >
          <ion-icon name="map" class="ion-padding-end"></ion-icon>
          {{ $t('HOME.relaypoints') }}
        </ion-button>

        <ion-button
          class="mc-big-button"
          color="primary"
          expand="block"
          fill="outline"
          v-on:click="redirectToFAQ()"
        >
          <ion-icon name="help-circle" class="ion-padding-end"></ion-icon>
          {{ $t('HOME.FAQ') }}
        </ion-button>

        <ion-button
          class="mc-big-button"
          color="primary"
          expand="block"
          fill="outline"
          v-on:click="redirectToCGU()"
        >
          <ion-icon name="document" class="ion-padding-end"></ion-icon>
          {{ $t('HOME.CGU') }}
        </ion-button>

        <ion-button v-if="showCommunitiesArticle"
          class="mc-big-button"
          color="primary"
          expand="block"
          fill="outline"
          v-on:click="redirectToCommunitiesArticle()"
        >
          <ion-icon name="people" class="ion-padding-end"></ion-icon>
          {{ $t('HOME.communities') }}
        </ion-button>

        <ion-button
          class="mc-big-button"
          color="primary"
          expand="block"
          fill="outline"
          v-on:click="redirectToContact()"
        >
          <ion-icon name="chatboxes" class="ion-padding-end"></ion-icon>
          {{ $t('HOME.contact') }}
        </ion-button>

        <ion-button
          class="mc-big-button"
          color="secondary"
          expand="block"
          v-if="this.appModule.HITCHHIKING"
          v-on:click="redirectHitchHiking()"
        >
          <img slot="start" alt="" style="width: 34px; margin-right: 16px; filter: brightness(0) invert(1);" :src="'/assets/hitchHiking.home.png'"/>
          {{ $t('HOME.hitchhiking').toUpperCase() }}
        </ion-button>

        <div v-if="partner" class="ion-margin text-center">
          <img class="partner-img" src="/assets/partner.png" alt="" />
        </div>

        <div class="text-center" v-if="version">
          <ion-text color="primary"><small style="opacity: 0.75">version {{version}}</small></ion-text>
        </div>
      </div>
    </ion-content>
  </div>
</template>

<style lang="scss">

.home-info {
  margin: 0px;
  margin-bottom: 16px;
}

.header-img-rezo {
  width: 150px;
  right: calc(50% - 75px);
  margin-right: 0px !important;
  position: fixed;
  top: 14px;
  z-index: 999999;
}

.plt-capacitor.plt-ios .header-img-rezo {
  top: 31px !important;
}

.mc-container {
  padding: 30px;
  background-image: url("/assets/banner.png");
  background-repeat: no-repeat;
  // background-size: 100%;
  background-size: cover;
  background-position: center;
  margin-bottom: -10px;
}

.mc-download-app {
  border-radius: 10px;
  margin-bottom: 20px;
  color: white;
  padding: 20px;
  background: rgba(var(--ion-color-primary-rgb), 0.4);

  p {
    margin: 0px;
    margin-bottom: 20px;
  }
}

.partner-img {
  width: 75%;
  object-fit: contain;
  // max-height: 100px;
}

.mc-home-header {
  .mc-home-log {
    display: flex;
    align-items: center;

    img {
      // width: 26px;
      height: 36px;
      margin-top: 6px;
      margin-bottom: 6px;
    }

    h1 {
      margin: 0;
      padding: 0;
      font-weight: bold;
    }

    p {
      margin: 0;
      padding: 0;
      font-weight: bold;
    }

    .mc-home-switch {
      margin-left: auto;
    }
  }
}
</style>

<script>
import UserHome from "./Components/UserHome.component";
import BlockAction from "./Components/BlockAction.component";
import ModuleModal from "../../Shared/Component/ModuleModal.component";
import SearchQuick from "../Shared/Components/SearchQuick.component";
import BannerCompletedAction from "../Gamification/BannerCompletedAction.vue";

import {isPlatform} from "@ionic/core";
import { Plugins } from '@capacitor/core';
import RelaypointsMap from "../Shared/Components/RelaypointsMap.component";
const { Device } = Plugins;


export default {
  name: "home",
  components: {
    UserHome,
    BlockAction,
    SearchQuick,
    BannerCompletedAction,
    RelaypointsMap,
  },
  data() {
    return {
      instance: process.env.VUE_APP_INSTANCE,
      name: process.env.VUE_APP_NAME,
      title: process.env.VUE_APP_TITLE,
      subtitle: process.env.VUE_APP_SUBTITLE,
      primary: "",
      secondary: "",
      success: "",
      partner: JSON.parse(process.env.VUE_APP_PARTNER),
      showModuleSelector: JSON.parse(process.env.VUE_APP_SHOW_MODULE),
      showSolidarity: JSON.parse(process.env.VUE_APP_SHOW_SOLIDARITY_TRANSPORT),
      appModule: JSON.parse(process.env.VUE_APP_MODULE),
      showEvents: JSON.parse(process.env.VUE_APP_SHOW_EVENTS),
      showCommunities: JSON.parse(process.env.VUE_APP_SHOW_COMMUNITIES),
      showRelaypoints: JSON.parse(process.env.VUE_APP_RELAYPOINTS),
      noIconToolbar: JSON.parse(process.env.VUE_APP_NO_ICON_TOOLBAR),
      noTextToolbar: JSON.parse(process.env.VUE_APP_NO_TEXT_TOOLBAR),
      showCommunitiesArticle: JSON.parse(process.env.VUE_APP_CREATE_COMMUNITY_ARTICLE),
      showMob: JSON.parse(process.env.VUE_APP_MOB),
      primeInfoUrl: process.env.VUE_APP_MOB_INFO_URL,
      langs: JSON.parse(process.env.VUE_APP_LANGS),
      isNotCapacitor: !isPlatform(window.document.defaultView, "capacitor"),
      solidaryLink: process.env.VUE_APP_SOLIDARITY_LINK,
      homeMessageDisplay: JSON.parse(process.env.VUE_APP_MESSAGE_HOME),
      version: null,
      selectedLanguage: null,
      displayedLanguage: null,
	    display:true,
      LMarker: null,
      showMap: false,
      solidaryType : JSON.parse(process.env.VUE_APP_MOB) ? 'mob': 'solidarity'
    };
  },
  created() {
    this.primary = window
      .getComputedStyle(document.body)
      .getPropertyValue("--ion-color-primary-rgb");
    this.secondary = window
      .getComputedStyle(document.body)
      .getPropertyValue("--ion-color-secondary-rgb");

    this.success = window
      .getComputedStyle(document.body)
      .getPropertyValue("--ion-color-success-rgb");

    const l = localStorage.getItem('language');
    this.displayedLanguage = !!l ? l : 'fr';
    this.$i18n.locale =!!l ? l : 'fr'
    // this.$store.state.userStore.user.language.code;
  },
  computed: {
    numberOfModule() {
      return Object.values(this.appModule).filter(item => item == true).length;
    },
    appMobileVersion(){
      return this.$store.state.appStore.version;
    },
  },
  mounted() {
    this.getVersion();
    // caching for crawlers
    setTimeout(() => {
      window.prerenderReady = true;
    }, 1000);
    this.getLocale();
  },
  methods: {
    getLocale : function() {
      this.$i18n.locale = this.displayedLanguage;
    },
    closeWelcome: function() {
      this.seeWelcome = false;
    },
  	closeInformation: function() {
   		this.display = false;
	},
    redirectToCommunities: function() {
      this.$router.push({ name: !!this.$store.state.userStore.user ? "communities" : "allcommunities" });
    },

    redirectToEvents: function() {
      this.$router.push({ name: "carpool-events" });
    },

    redirectToFAQ: function() {
      this.$router.push({
        name: "article",
        params: { id: 10 }
      });
    },

    redirectToCGU: function() {
      this.$router.push({
        name: "article",
        params: { id: 1 }
      });
    },

    redirectToCommunitiesArticle: function() {
      this.$router.push({
        name: "article",
        params: { id: 12 }
      });
    },

    redirectToContact: function() {
      this.$router.push({ name: "carpool-contact" });
    },

    redirectToSolidarity: function() {
      if (this.solidaryLink == "") {
        this.$router.push({ name: "carpool.solidary.home.request" });
      } else {
        this.$router.push({ name: "carpool-solidarity" });
      }
    },

    redirectToMob: function() {
      this.$router.push({ name: "mob-help" });
    },

    redirectToSolidarityPost: function() {
      this.$router.push({ name: "post-carpool", params: { solidarity: true } });
    },

    redirectToRelaypoints: function() {
      this.$router.push({ name: "carpool-relaypoints" });
    },


    showModule: async function(ev) {

       const modal = await this.$ionic.popoverController
        .create({
          component: ModuleModal,
          componentProps: {
            propsData: {
              appModule: this.appModule,
              router: this.$router
            },
          },
          event: ev,
          translucent: true,
          cssClass: "modulePopover"
        });

        await modal.present();
    },
    async getVersion() {
      if (isPlatform(window.document.defaultView, "capacitor")) {
        let info = await Device.getInfo();
        this.version = info.appVersion;
      }
    },
    async showLangs() {
      const buttons = [];
      this.langs.forEach(item => {
        buttons.push({
          text: this.$t('Langs.' + item),
          handler: () => {
            this.setLang(item)
          }
        });
      })
      buttons.push(
        {
          text: this.$t('Commons.cancel'),
          role: 'cancel',
        },
      );

      const actionSheet = await this.$ionic.actionSheetController
        .create({
          header: this.$t('Langs.change'),
          buttons: buttons,
        });
      return actionSheet.present();
    },
    redirectHitchHiking() {
      this.$router.push({name: 'hitchHiking.home'})
    },
    setLang(item) {
      this.selectedLanguage = item;
      this.$i18n.locale = this.selectedLanguage;
      localStorage.setItem('language', this.selectedLanguage);

      const payload = {
        userId: this.$store.getters.userId,
        language: {
            code: item
        }
      };

      if(this.$store.getters.userId){
        this.$store.dispatch('updateLanguage', payload )
        .then(() =>  {
            this.$store.commit("user_update_language_success");
        })
        .catch((error) => {
          this.presentToast(this.$t("Commons.error"), "danger");
        });
      }
    },
  }
};
</script>
